<template>
  <v-layout row justify-space-between>
    <v-flex v-if="step.expedition_field" xs12>
      <template v-if="!step.validated && expedition_field">
        <v-text-field
          prepend-icon="edit"
          :label="step.expedition_field.expedition_field_template.name"
          v-model="expedition_field.value"
          background-color="white"
          box
          v-if="
            step.expedition_field.expedition_field_template.value_type ==
            'string'
          "
        />

        <v-checkbox
          :label="step.expedition_field.expedition_field_template.name"
          v-model="expedition_field.value"
          flat
          height="16"
          box
          v-if="
            step.expedition_field.expedition_field_template.value_type ==
            'boolean'
          "
        />

        <v-text-field
          prepend-icon="edit"
          :label="step.expedition_field.expedition_field_template.name"
          v-model="expedition_field.value"
          background-color="white"
          box
          type="number"
          v-if="
            step.expedition_field.expedition_field_template.value_type ==
            'integer'
          "
        />

        <date-field
          :currentDate="expedition_field.value"
          v-model="expedition_field.value"
          :label="step.expedition_field.expedition_field_template.name"
          v-if="
            step.expedition_field.expedition_field_template.value_type == 'date'
          "
        />
      </template>

      <!-- <v-btn class="primary" @click="sendFieldValue()" v-show="!step.validated && step.expedition_field.expedition_field_template.value_type != 'boolean'">OK</v-btn> -->
      <v-btn
        class="primary"
        @click="sendFieldValue()"
        v-show="!step.validated"
        small
      >
        <v-icon small class="pr-2">mdi-shield-check</v-icon>Confirm Input
      </v-btn>
      <v-flex pa4 v-show="step.validated" class="grey--text text--darken-2">
        <div
          v-if="
            step.expedition_field.expedition_field_template.value_type ==
            'boolean'
          "
        >
          <v-subheader>
            {{
              step.expedition_field &&
              step.expedition_field.expedition_field_template.name
            }}
            has
            {{ expedition_field && expedition_field.value ? "" : "not" }} been
            validated
          </v-subheader>
        </div>
        <div v-else>
          <v-subheader>
            {{
              step.expedition_field &&
              step.expedition_field.expedition_field_template.name
            }}
          </v-subheader>
          <h4 class="pl-3 pb-3">
            <span
              v-if="
                step.expedition_field &&
                step.expedition_field.expedition_field_template.value_type ==
                  'date'
              "
              >{{
                expedition_field &&
                expedition_field.value &&
                timeToDate(expedition_field.value)
              }}</span
            >
            <span v-else>{{ expedition_field && expedition_field.value }}</span>
          </h4>
        </div>
      </v-flex>
    </v-flex>
    <div v-else>Error : no expedition field</div>
  </v-layout>
</template>

<script>
import SEND_STEP_INPUT_FIELD from "../../graphql/steps/send_step_input_field.gql";
import dateField from "../shared/dateField";
import date from "../../mixins/date.js";

export default {
  mixins: [date],
  components: {
    dateField,
  },
  props: {
    step: {
      type: Object,
      required: true,
    },
    action_done: {
      type: Boolean,
    },
  },
  data() {
    return {
      expedition_field: {
        id: "",
        value: "",
      },
    };
  },
  methods: {
    sendFieldValue() {
      const variables = {
        id: this.expedition_field.id,
        value: this.expedition_field.value.toString(),
      };
      console.log(this.expedition_field.value, variables);
      this.sendMutation(
        "sent",
        "Information",
        SEND_STEP_INPUT_FIELD,
        variables
      ).then(() => {
        if (this.expedition_field.value) this.$emit("update:actionDone", true);
      });
    },
  },
  mounted() {
    this.expedition_field = this.step.expedition_field;
  },
};
</script>
